import React from 'react';
import { Box, Flex } from 'rebass/styled-components';

import { userSelector } from 'redux/selectors';
import { useSelector } from 'react-redux';
import { SettingsLayoutHeader } from '../../../components/atoms/settingsLayoutHeader';
import usePageHook from '../../../hooks/usePageHook';
import LoginInfo from '../../Account/LoginInfo';
import RequestData from '../../Account/RequestData';
import DeleteAccount from '../../Account/DeleteAccount';
import MFASettings from './MFASettings';

const pageTitle = 'Your Getro Account';

export const MyAccount = () => {
  usePageHook(pageTitle);
  const { isOnlyAlly } = useSelector(userSelector);

  return (
    <Box maxWidth="600px">
      <SettingsLayoutHeader title={pageTitle} description="Manage your Getro account." />
      <Flex pt="32px" sx={{ flexDirection: 'column', gap: '40px' }}>
        <LoginInfo />
        <MFASettings />
        {!isOnlyAlly && <RequestData />}
        {!isOnlyAlly && <DeleteAccount />}
      </Flex>
    </Box>
  );
};
